import { createReporter, type Reporter, type ReporterOptions } from "./index.ts";

/** Erros que não são do nosso código (extensões, rede caindo, navegação abortada): não vão ao GlitchTip. */
const IGNORED = [
  /ResizeObserver loop/i,
  /^Script error\.?$/i,
  /Failed to fetch|NetworkError|Load failed|network error/i,
  /AbortError|The (user|operation) aborted/i,
  /extension:\/\//i,
];

function ignored(error: unknown): boolean {
  const text = error instanceof Error ? `${error.name}: ${error.message}\n${error.stack ?? ""}` : String(error);
  return IGNORED.some((re) => re.test(text));
}

let current: Reporter | null = null;

/**
 * Liga o envio no navegador: erros não tratados e promessas rejeitadas sem tratamento. Chamar uma vez, antes de
 * montar o app. Sem DSN, não faz nada.
 */
export function installBrowserReporting(opts: Omit<ReporterOptions, "platform">): Reporter {
  const reporter = createReporter({ ...opts, platform: "javascript" });
  current = reporter;
  if (!reporter.enabled || typeof window === "undefined") return reporter;
  window.addEventListener("error", (ev) => {
    const err = ev.error ?? ev.message;
    if (!err || ignored(err)) return;
    reporter.capture(err, { url: location.href, where: location.pathname });
  });
  window.addEventListener("unhandledrejection", (ev) => {
    if (!ev.reason || ignored(ev.reason)) return;
    reporter.capture(ev.reason, { url: location.href, where: location.pathname });
  });
  return reporter;
}

/** Envia um erro tratado (ex.: tela de erro do roteador). Sem envio ligado, não faz nada. */
export function reportError(error: unknown, where?: string): void {
  if (!current || ignored(error)) return;
  current.capture(error, {
    url: typeof location === "undefined" ? undefined : location.href,
    where: where ?? (typeof location === "undefined" ? undefined : location.pathname),
  });
}
